import React from 'react'
import api from '../../api'

const getStoreKey = (path) =>
    `CANDY_FERGUS_LOGS_${path.toUpperCase().replace(/[^A-Z0-9]/i, '_')}`

export default class Base extends React.Component {
    constructor(props) {
        super(props)

        this.path = ''
        this.intervalId = null
        this.state = {
            loading: false,
            rawResult: {},
            results: [],
            status: '',
            page: 0,
            search: '',
            counter: 0,
        }

        this.getQueryResult.bind(this)
        this.startQuery.bind(this)
    }

    getQueryId() {
        const {
            location: { query },
        } = this.props

        return query.queryId || null
    }

    get storeKey() {
        return `CANDY_FERGUS_LOGS_${this.path
            .toUpperCase()
            .replace(/[^A-Z0-9]/i, '_')}`
    }

    async getQueryResult(queryId) {
        if (!this.path) {
            return
        }

        const rawResult = await api.get(`${this.path}/${queryId}`)
        const { status } = rawResult.value
        this.setState({ status, rawResult })
        if (status === 'Complete') {
            this.setState({
                loading: false,
            })
        }

        if (typeof this.formatResults === 'function') {
            this.setState({
                results: this.formatResults(rawResult),
            })
        }
    }

    async startQuery() {
        const { history } = this.props

        this.setState({ loading: true, counter: 0 })
        const result = await api.post(this.path)
        const queryId = result.value.queryId
        if (queryId) {
            history.push(`${location.pathname}?queryId=${queryId}`)
            this.setState({ status: '' }, () => {
                this.refreshQuery()
            })
            localStorage.setItem(
                this.storeKey,
                JSON.stringify({
                    queryId,
                })
            )
        }
    }

    async refreshQuery() {
        const { status, counter } = this.state
        if (status === 'Complete') {
            return
        }

        this.setState({ loading: true, counter: counter + 1 })
        await this.getQueryResult(this.getQueryId())

        setTimeout(async () => {
            this.refreshQuery()
        }, 5000)
    }

    componentDidMount() {
        const queryId = this.getQueryId()
        if (queryId) {
            this.refreshQuery()
            localStorage.setItem(
                this.storeKey,
                JSON.stringify({
                    queryId,
                })
            )
        } else {
            try {
                const { history } = this.props
                const settings = JSON.parse(localStorage.getItem(this.storeKey))
                if (settings.queryId) {
                    history.push(
                        `${location.pathname}?queryId=${settings.queryId}`
                    )
                    this.getQueryResult(settings.queryId)
                }
            } catch (_e) {
                localStorage.setItem(this.storeKey, JSON.stringify({}))
            }
        }
    }
}



// WEBPACK FOOTER //
// ./app/pages/FergusLogs/Base.js